<template>
    <transition name="slide-fade">
        <div class="modal" data-cy="modal_mission_confirm" :class="{'open' : open}" v-if="open">
            <div class="modal-content">
                <div class="bg-white w-full rounded-sm text-a-blue-001b73">
                    <img class="fixed left-0 right-0 w-40 h-48 mx-auto -mt-20" :src="initImageUrls()">
                    <div class="pt-28">
                        <div class="text-center text-20 font-medium mb-2 pt-3 px-5" v-html="title"></div>
                        <div class="text-center text-16 font-regular px-5" v-html="message"></div>
                    </div>
                    <div class="w-full px-5 pb-5 pt-4">
                        <div>
                            <button class="w-full btn bg-a-blue-2140a6 text-a-white-ffffff font-bold text-18 rounded-sm py-1 mb-4" data-cy="btn_mission_confirm_ok" @click="clickOk()">
                                {{btnOk}}
                            </button>
                        </div>
                        <div>
                            <button class="w-full btn bg-a-white-ffffff border border-a-blue-2140a6 font-bold text-a-blue-2140a6 text-18 rounded-sm py-1" data-cy="btn_mission_confirm_cancel" @click="clickCancel()">
                                {{btnCancel}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>

    <transition name="fade">
        <div class="modal-backdrop" v-if="open"></div>
    </transition>
</template>
<script>
import Util from "@/helper/Utility.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ConfigManager from "@/config/ConfigManager.js";
export default {
    name: "MissionConfirmModal",
    mixins: [LocaleMixin],
    props: {
        controller: Object,
    },
    data: function() {
        return {
            open: false,

            title: '',
            message: '',
            btnOk: '',
            btnCancel: '',
            busModal: null,
        };
    },
    created: function() {
        this.busModal = this.controller.busModal;
    },
    mounted: function() {
        this.busModal.on('show', this.show);
        this.busModal.on('hide', this.hide);
    },
    watch: {
        '$route.path': function() {
            if (this.open) {
                this.hide();
            }
        },
    },
    methods: {
        show: function(config) {
            this.title = config.title;
            this.message = config.msg;
            this.btnOk = config.btnOk;
            this.btnCancel = config.btnCancel;

            if (Util.isEmptyStr(this.btnOk)) {
                this.btnOk = this.lbl.button.confirm;
            }
            if (Util.isEmptyStr(this.btnCancel)) {
                this.btnCancel = this.lbl.button.cancel;
            }

            document.body.classList.add('not-scroll');
            this.open = true;
        },
        hide: function() {
            document.body.classList.remove('not-scroll');
            this.open = false;
        },
        clickOk: function () {
            this.hide();
            this.controller.sendCallbackOk();
        },
        clickCancel: function() {
            this.hide();
            this.controller.sendCallbackCancel();
        },
        initImageUrls: function() {
            var appId = ConfigManager.getAppId();
            var baseUrl = ConfigManager.getBlobUrl()+ `/webconfig/${appId}/images/`;
            
            // images loading
            return baseUrl + 'image/modalconfirm/img-fish-confirm.png'; //ต้องแก้รูปหลังเอาขึ้นด้วย
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/base.scss";
    @import "@/style/modal.scss";
    .modal {
        @extend %modal;

        .modal-content {
            width: 420px;

            @include mobile {
                width: 100%;
                padding: 20px;
            }
        }
        .btn {
            height: 50px;
        }
    }
</style>
